import { QuestionGroup } from "@cirrus-author/questions/types"
import { CollectionItemType } from "@cirrus-author/questions/types/QuestionType/CollectionItemTypeNumeric"

export const LibraryTabs = {
  Collections: "collections",
  Items: "items",
  Media: "media",
}

export enum CollectionFolder {
  Undefined = 0,
  all = 1,
  active = 2,
  withdrawn = 3
}

export enum WorkflowState {
  Undefined = 0,
  Live = 1,
  Draft = 2,

  // [Description("Ready for review")]
  ReadyForReview = 3,

  //Archived = 4,

  // [Description("Reviewed - approved")]
  Approved = 5,

  // [Description("Reviewed - not approved")]
  NotApproved = 6,

  Withdrawn = 7
}

export const WorkflowStateI18nKey = {
  [WorkflowState.Draft]: "WorkflowState:Draft",
  [WorkflowState.ReadyForReview]: "WorkflowState:ReadyForReview",
  [WorkflowState.NotApproved]: "WorkflowState:NotApproved",
  [WorkflowState.Approved]: "WorkflowState:Approved",
  [WorkflowState.Live]: "WorkflowState:Live",
  [WorkflowState.Withdrawn]: "WorkflowState:Withdrawn",
}

export const FolderI18nKey = {
  [CollectionFolder.all]: "General:All",
  [CollectionFolder.active]: "Filter.Filters:Active",
  [CollectionFolder.withdrawn]: "WorkflowState:Withdrawn",
}

export interface ItemDefinition {
  group: QuestionGroup;
  key: string;
  title: string;
}

export interface ItemDefinitionsMap {
  [key: number]: ItemDefinition;
}

export const QuestionTypeMapping: ItemDefinitionsMap = {
  [CollectionItemType.EitherOr]: {
    group: QuestionGroup.closed,
    key: "Question.Types:EitherOr",
    title: "CollectionItemType:EitherOr",
  },
  [CollectionItemType.MultipleChoice]: {
    group: QuestionGroup.closed,
    key: "Question.Types:MultipleChoice",
    title: "CollectionItemType:MultipleChoice",
  },
  [CollectionItemType.MultipleResponse]: {
    group: QuestionGroup.closed,
    key: "Question.Types:MultipleResponse",
    title: "CollectionItemType:MultipleResponse",
  },
  [CollectionItemType.ShortAnswer]: {
    group: QuestionGroup.open,
    key: "Question.Types:ShortAnswer",
    title: "CollectionItemType:ShortAnswer",
  },
  [CollectionItemType.Essay]: {
    group: QuestionGroup.open,
    key: "Question.Types:Essay",
    title: "CollectionItemType:Essay",
  },
  [CollectionItemType.Numeric]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Numeric",
    title: "CollectionItemType:Numeric",
  },
  [CollectionItemType.Match]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Match",
    title: "CollectionItemType:Match",
  },
  [CollectionItemType.Order]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Order",
    title: "CollectionItemType:Order",
  },
  [CollectionItemType.Hotspot]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Hotspot",
    title: "CollectionItemType:Hotspot",
  },
  [CollectionItemType.FileResponse]: {
    group: QuestionGroup.open,
    key: "Question.Types:FileResponse",
    title: "CollectionItemType:FileResponse",
  },
  [CollectionItemType.FillInTheBlankText]: {
    group: QuestionGroup.closed,
    key: "Question.Types:FillInTheBlank",
    title: "CollectionItemType:FillInTheBlankText",
  },
  // [CollectionItemType.Equation]: {
  //   key: "Question.Types:EquationEntry",
  // },
  [CollectionItemType.SelectFromTheList]: {
    group: QuestionGroup.closed,
    key: "Question.Types:SelectFromList",
    title: "CollectionItemType:SelectFromTheList",
  },
  [CollectionItemType.Sowiso]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Sowiso",
    title: "CollectionItemType:Sowiso",
  },
  [CollectionItemType.Section]: {
    group: QuestionGroup.pages,
    key: "CollectionItemType:Section",
    title: "CollectionItemType:Section",
  },
  [CollectionItemType.ExtendedMatch]: {
    group: QuestionGroup.closed,
    key: "CollectionItemType:ExtendedMatch",
    title: "CollectionItemType:ExtendedMatch",
  },
  [CollectionItemType.DragAndDrop]: {
    group: QuestionGroup.closed,
    key: "Question.Types:DragAndDrop",
    title: "Question.Types:DragAndDrop",
  },
  [CollectionItemType.AssessmentPage]: {
    group: QuestionGroup.pages,
    key: "CollectionItemType:AssessmentPage",
    title: "CollectionItemType:Page",
  },
  [CollectionItemType.Programming]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Vpl",
    title: "Question.Types:Vpl",
  },
  [CollectionItemType.ComprehensiveIntegratedPuzzle]: {
    group: QuestionGroup.closed,
    key: "Question.Types:Cip",
    title: "Question.Types:Cip",
  },
  [CollectionItemType.ExtendedMultipleChoice]: {
    group: QuestionGroup.closed,
    key: "Question.Types:ExtendedMultipleChoice",
    title: "CollectionItemType:ExtendedMultipleChoice",
  },
  [CollectionItemType.FinancialStatement]: {
    group: QuestionGroup.closed,
    key: "Question.Types:FinancialStatement",
    title: "QuestionTypes:FinancialStatement",
  },
}

export const ANGOFF_SETTINGS_DEFAULT = {
  hardLow:    0.00,
  hardHigh:   0.30,
  mediumLow:  0.31,
  mediumHigh: 0.70,
  easyLow:    0.71,
  easyHigh:   1.00,
  useAngoff: false
}

export const ANGOFF_STEP = 0.01
